import { Card, CardBody, Spinner } from 'reactstrap';

export const SuspectedReportCardLoading = () => {
  return (
    <Card>
      <CardBody
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ minHeight: 300 }}
      >
        <Spinner color="primary" />

        <p className="text-muted mt-3 mb-0">Carregando resultados...</p>
      </CardBody>
    </Card>
  );
};
